import React from "react";
import { Link } from "react-router-dom";
import { IMG_URL } from "../App";

function CardComponent({ post, sizeTag, category }) {
  return (
    <Link
      to={`/publicaciones/${post.title
        ?.replaceAll("/", "-")
        .split(" ")
        .join("-")
        .toLowerCase()}/${post.id}`}
    >
      <div className={`${sizeTag ? sizeTag + "__post" : "card__post"}`}>
        {post.contents &&
        post.contents[0] &&
        post.contents[0].publicationType !== "video" ? (
          <img
            src={`${IMG_URL}/content/${post.contents[0]?.path}`}
            alt="postImage"
            className="card__postImage"
          />
        ) : post.contents && !post.contents[0] ? (
          <img src="/no-image.jfif" alt="noPostImage" />
        ) : (
          <></>
        )}
        <div
          className={`${
            sizeTag ? sizeTag + "__postContent" : "card__postContent"
          }`}
        >
          <span
            className={`${
              sizeTag ? sizeTag + "__postCategory" : "card__postCategory"
            }`}
          >
            {category}
          </span>
          <span
            className={`${
              sizeTag ? sizeTag + "__postTitle" : "card__postTitle"
            }`}
          >
            {post.title}
          </span>
          <span
            className={`${
              sizeTag ? sizeTag + "__postDescription" : "card__postDescription"
            }`}
          >
            {post.description}
          </span>
        </div>
      </div>
    </Link>
  );
}

export default CardComponent;
